<i18n>
{
    "en": {},
    "ru": {
        "title": "О проекте",
        "title_editorial": "Редакция Aromo",
        "descriptionFirst": "Aromo — онлайн-проект о парфюмерии в России и мире. Мы объединили функции энциклопедии, журнала и креативного пространства для независимых авторов так, чтобы у пользователей была возможность не только узнать все об ароматах, но и стать частью постоянно растущего сообщества.",
        "descriptionSecond": "Наши читатели — активные, заинтересованные, открытые новому и не боящиеся экспериментов любители парфюмерии и всего, что связано с темой обоняния. Для нас духи — и ежедневное удовольствие, и тема для вдумчивого, глубокого разговора; мы пишем о том, какую роль играют ароматы в истории, просто отвечаем на сложные вопросы и честно рассказываем, на какие новинки стоит обратить внимание, а какие можно обойти стороной.",
        "descriptionThird": "Aromo говорит о парфюмерии понятным языком и смотрит на нее современным взглядом: в нашем понимании это не средство соблазнения, но один из способов сделать жизнь красивее и объемнее — такой же, как искусство, хорошая литература и высокая гастрономия.",
        "write": "Написать",
        "meta": {
            "title": "О проекте",
            "description": "Aromo — онлайн-проект о парфюмерии в России и мире. Мы объединили функции энциклопедии, журнала и креативного пространства для независимых авторов так, чтобы у пользователей была возможность не только узнать все об ароматах, но и стать частью постоянно растущего сообщества."
        }
    }
}
</i18n>
<template>
    <div class="page-about">
        <div class="page-about__block">
            <PageBlock>
                <Breadcrumb
                    :items="breadcrumbs"/>
                <SectionCard :loaded="loaded" class="page-about__wrapper">
                    <template #main>
                        <div class="page-about__content">
                            <PageBlock
                                :big-title="!isDeviceDesktop"
                                :title="$t('title')"
                                small-header
                                content-padding
                                content-visible
                                class="page-about__description"
                                :heading-tag="'h1'">

                                <picture class="page-about__cover">
                                    <img
                                        v-lazy-load data-src="/img/about/about.jpg"
                                        :alt="$t('title')"/>
                                </picture>

                                <p class="page-about__description-text">{{ $t('descriptionFirst') }}</p>
                                <p class="page-about__description-text">{{ $t('descriptionSecond') }}</p>
                                <p class="page-about__description-text">{{ $t('descriptionThird') }}</p>

                                <div class="page-about__counts">
                                    <nuxt-link
                                        to="/perfumes/"
                                        class="page-about-count">
                                        <span class="page-about-count__num">{{ perfumesCount }}</span>
                                        <span class="page-about-count__name">{{ perfumesDeclension }}</span>
                                    </nuxt-link>

                                    <nuxt-link
                                        to="/brands/"
                                        class="page-about-count">
                                        <span class="page-about-count__num">{{ brandsCount }}</span>
                                        <span class="page-about-count__name">{{ brandsDeclension }}</span>
                                    </nuxt-link>

                                    <nuxt-link
                                        to="/noses/"
                                        class="page-about-count">
                                        <span class="page-about-count__num">{{ nosesCount }}</span>
                                        <span class="page-about-count__name">{{ nosesDeclension }}</span>
                                    </nuxt-link>

                                    <nuxt-link
                                        to="/notes/"
                                        class="page-about-count">
                                        <span class="page-about-count__num">{{ notesCount }}</span>
                                        <span class="page-about-count__name">{{ notesDeclension }}</span>
                                    </nuxt-link>
                                </div>

                            </PageBlock>

                            <PageBlock
                                v-if="showEditors"
                                big-title
                                :title="$t('title_editorial')"
                                small-header
                                content-padding
                                content-visible
                                class="page-about__editorial">

                                <article
                                    v-for="(item, index) in editorsList"
                                    :key="`editor-aromo-${index}`"
                                    class="editor-aromo">

                                    <nuxt-link
                                        :to="'/users/'+item.id+'/'"
                                        class="editor-aromo__picture-wrapper">
                                        <picture class="editor-aromo__picture">
                                            <img v-lazy-load :data-src="get(item, 'photo.url', getEntityNoImage('user'))" :alt="get(item, 'name', '')"/>
                                        </picture>
                                    </nuxt-link>

                                    <div class="editor-aromo__content">
                                        <h5 class="editor-aromo__name">
                                            <nuxt-link
                                                :to="'/users/'+item.id+'/'"
                                                class="editor-aromo__name-link">
                                                {{ get(item, 'name', '')}}
                                            </nuxt-link>
                                            <!-- <a
                                                :href="aromoEmail"
                                                class="editor-aromo__name-link">
                                                {{ get(item, 'name', '')}}
                                            </a> -->
                                        </h5>
                                        <span class="editor-aromo__position">{{ get(item, 'position', '') }}</span>
                                        <p class="editor-aromo__text">{{ get(item, 'text', '') }}</p>

                                        <!-- <a
                                            v-if="$auth.loggedIn"
                                            href="#"
                                            class="editor-aromo__link"
                                            @click.prevent="goToMessage(get(item, 'id', ''))">
                                            {{ $t('write') }}
                                        </a>

                                        <a
                                            :href="aromoEmail"
                                            v-else
                                            class="editor-aromo__link">
                                            {{ $t('write') }}
                                        </a> -->
                                    </div>
                                </article>

                            </PageBlock>
                        </div>
                    </template>
                </SectionCard>
            </PageBlock>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import get from "lodash/get";
import PageBlock from '@/components/layout/AppPageBlock'
import Breadcrumb from '@/components/layout/nav/Breadcrumb'
import SectionCard from '@/components/layout/AppSectionCard'

export default {
    name: 'AboutPage',
    components: {
        Breadcrumb,
        PageBlock,
        SectionCard
    },
    asyncData({app, query, params, state}) {
        const baseUrl = app.i18n.__baseUrl
        const breadcrumbs = [
            {
                path: baseUrl,
                name: app.i18n.t('breadcrumbs.home_page'),
            },
            {
                name: app.i18n.t('breadcrumbs.about'),
            }
        ];

        return {
            breadcrumbs
        }
    },
    data() {
        return {
            showEditors: false,
            loaded: false,
            aromoEmail: 'mailto:info@aromo.ru',
            editorsList: [
                {
                    name: 'Алена Чудакова',
                    position: 'Руководитель энциклопедии, автор',
                    text: 'Ищет баланс между содержанием и формой. Любит выразительные и необычные гурманские запахи. Парфюмерию считает органичной частью своей жизни.',
                    id: '15917',
                    photo: {
                        url: '/img/editors/editor_3.png'
                    }
                },
                {
                    name: 'Анастасия Большакова',
                    position: 'Редактор энциклопедии',
                    text: 'Любит красоту в любом проявлении. Нравится пробовать новые ароматы и пополнять свои знания в парфюмерии. Предпочитает легкие ароматы с оттенками пудровой сладости.',
                    id: '99656',
                    photo: {
                        url: '/img/editors/editor_10.jpeg'
                    }
                },
                {
                    name: 'Алина Черник',
                    position: 'Редактор энциклопедии',
                    text: 'Любит творчество и фантазии, в них же ищет вдохновение. Считает, что красота это весь мир. Поклонница чайных ароматов с частичкой кислинки и всплеском свежих фруктов.',
                    id: '57687',
                    photo: {
                        url: '/img/editors/editor_8.jpeg'
                    }
                },
                // {
                //     name: 'Анастасия Кузнецова',
                //     position: 'Выпускающий редактор, автор',
                //     text: 'Главный интерес – парфюмерные запуски: от составления брифа до маркетинговой стратегии. Обожает интересные запахи, слепые тесты и кофейные дегустации. Не выходит из дома без дорожного флакона UER MI.',
                //     id: '59741',
                //     photo: {
                //         url: '/img/editors/editor_6.png'
                //     }
                // },
                {
                    name: 'Валерий Михалицын',
                    position: 'Автор',
                    text: 'Верит, что красота спасёт мир. Любит парфюмерию за факт существования и считает её сложнейшим из искусств. Из всего душистого предпочитает качественное.',
                    id: '15909',
                    photo: {
                        url: '/img/editors/editor_4.png'
                    }
                },
                {
                    name: 'Екатерина Коробкина',
                    position: 'SMM-менеджер',
                    text: 'Главная поклонница пудровых ароматов. Онлайн 24/7/365. Любит красивые инстаграм-профили, грамотный SMM, ретро-флаконы и бренды с историей. Отчаянно не считает себя парфюмерным маньяком.',
                    id: '14093',
                    photo: {
                        url: '/img/editors/editor_5.png'
                    }
                }
            ],
            editorId: null
        }
    },
    computed: {
        ...mapGetters(['isDeviceDesktop', 'getEntityNoImage']),
        ...mapState('entities', ['counters']),
        perfumesCount() {
            return this.$options.filters.numberFormat(get(this.counters, 'perfumes.total', 0))
        },
        perfumesDeclension() {
            return this.$options.filters.numberDeclension(this.perfumesCount, this.$t('declensions.perfumes'),false)
        },

        brandsCount() {
            return this.$options.filters.numberFormat(get(this.counters, 'brands.total', 0))
        },
        brandsDeclension() {
            return this.$options.filters.numberDeclension(this.brandsCount, this.$t('declensions.brands'),false)
        },

        notesCount() {
            return this.$options.filters.numberFormat(get(this.counters, 'notes.total', 0))
        },
        notesDeclension() {
            return this.$options.filters.numberDeclension(this.notesCount, this.$t('declensions.notes'),false)
        },

        nosesCount() {
            return this.$options.filters.numberFormat(get(this.counters, 'perfumers.total', 0))
        },
        nosesDeclension() {
            return this.$options.filters.numberDeclension(this.nosesCount, this.$t('declensions.noses'),false)
        },
        userId() {
            return get(this.$auth, 'user.id', undefined)
        },
        metaDefault() {
            return {
                title: this.$t('meta.title'),
                description: this.$t('meta.description'),
                // "og:description": this.$t('meta.description'),
                // "og:title": this.$t('meta.title')
            };
        }
    },
    mounted() {
        this.loaded = true;
    },
    globalBus: {
        'auth-complete'() {
            if(this.editorId !== null) {
                this.$router.push(
                    {
                        name: 'users.messages.dialog',
                        params: {
                            userId: get(this.$auth, 'user.id', null),
                            secondUserId: this.editorId
                        }
                    })
            }
        }
    },
    methods: {
        get,
        ...mapActions({
            'getCounters': 'entities/getCounters',
        }),
        goToMessage(editorId) {
            // if(!this.$auth.loggedIn) {
            //     this.editorId = editorId
            //     this.showPopup('signin')
            // } else {
            this.$router.push(
                {
                    name: 'users.messages.dialog',
                    params: {
                        userId: get(this.$auth, 'user.id', null),
                        secondUserId: editorId
                    }
                })
            // }
        }
    },
    head() {
        return {
            title: this.$options.filters.metaSitenameTitle(this.metaDefault.title),
            meta: this.$options.filters.metaApiExtract({meta: this.metaDefault})
        }
    }
}
</script>

<style lang="less">
.page-about {
    .breadcrumb {
        margin-bottom: rem(3);
    }

    &__wrapper {
        @{desktop} & {
            margin: 0 auto;
            padding-top: rem(16);

            max-width: 700px;
        }
    }

    &__cover{
        display: block;

        margin-bottom: rem(16);

        max-width: 100%;

        @{desktop} & {
            margin-bottom: rem(32);
        }

        &>img{
            display: inline-block;

            height: 172px / 375px * 100vw;
            max-width: 100%;

            @{desktop} & {
                height: 360px;
            }
        }
    }

    &__picture {
        background-image: url('/img/about_promo.svg');
        background-position: center;
        background-size: cover;

        margin-bottom: rem(16);

        height: 223px / 375px * 100vw;
        width: 100%;

        @{desktop} & {
            margin: 0 auto;
            margin-top: rem(-27);
            margin-bottom: rem(12);

            height: rem(360);
            max-width: rem(541);
        }
    }

    &__description {
        &-text {
            line-height: 1.75;

            margin-bottom: rem(12);
        }

        .page-block__content {
            padding-top: rem(5);
        }
    }

    &__counts {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: rem(16);

        padding-top: rem(20);

        @{desktop} & {
            grid-template-columns: repeat(4, 1fr);
            gap: rem(20);
        }
    }

    &__editorial {
        margin-bottom: 0;
        padding-top: rem(30);

        @{desktop} & {
            padding-top: rem(22);

            .page-block__title {
                font-size: rem(22);
            }
        }
    }

    @{desktop} & {
        padding-bottom: rem(80);
    }
}

.page-about-count {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;

    border: 1px solid @color-gray-white;
    border-radius: 3px;

    height: 160px / 375px * 100vw;

    &__num {
        color: @color-violet;
        font-size: rem(32);
        font-weight: 500;
    }

    &__name {
        color: @color-black;
        font-weight: 500;
    }

    @{desktop} & {
        height: rem(160);

        transition: box-shadow 0.2s;

        &:hover {
            box-shadow: 0 rem(1) rem(8) rgba(0, 0, 0, 0.1);

            transition: box-shadow 0.2s;
        }
    }
}

.editor-aromo {
    --size-picture: rem(48);
    display: flex;

    border-top: 1px solid @color-gray-white;

    padding-top: rem(19);
    padding-bottom: rem(19);

    align-items: flex-start;

    &__picture {
        border-radius: 50%;

        height: var(--size-picture);
        width: var(--size-picture);

        overflow: hidden;
        display: block;
        backface-visibility: hidden;
        transform: translate3d(0, 0, 0);

        img {
            object-fit: cover;

            height: var(--size-picture);
            width: var(--size-picture);
        }
    }

    &__content {
        padding-left: rem(16);

        width: calc(100% - var(--size-picture));

        @{desktop} & {
            padding-left: rem(24);
        }
    }

    &__name {
        font-size: rem(15);
        font-weight: 500;

        margin-bottom: rem(2);
        padding-top: rem(3);

        &-link {
            color: inherit;

            transition: color .15s ease;

            .hover({
                color: @color-primary;
            });
        }

        @{desktop} & {
            font-size: rem(18);

            margin-bottom: rem(7);
        }
    }

    &__position {
        display: inline-block;

        font-size: rem(13);

        margin-bottom: rem(14);

        width: 100%;

        @{desktop} & {
            font-size: rem(15);

            margin-bottom: rem(13);
        }
    }

    &__text {
        // .text-ellipsis(4);
        color: @color-gray;
        font-size: rem(13);
        line-height: 1.6;

        margin-bottom: rem(10);

        // max-height: rem(80);

        overflow: hidden;

        @{desktop} & {
            font-size: rem(15);
            line-height: 1.5;

            margin-bottom: rem(14);
        }
    }

    &__link {
        color: @color-violet;
        font-size: rem(13);

        .hover({
            text-decoration: underline;
        });

        @{desktop} & {
            font-size: rem(15);
        }
    }

    @{desktop} & {
        --size-picture: rem(118);

        padding-top: rem(23);
        padding-bottom: rem(23);
    }
}
</style>
